module.exports = __webpack_public_path__ + "static/img/20004 (4).d5e913b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20004 (4).webp
// module id = cDG/
// module chunks = 14